<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <!--订单进度-->
    <!-- <el-steps :active="active" finish-status="success">
        <el-step title="下单时间"></el-step>
        <el-step title="付款"></el-step>
        <el-step title="发货"></el-step>
        <el-step title="收货"></el-step>
        <el-step title="完成"></el-step>
        </el-steps> -->
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
              {{ detail.order_no }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">买家：</span>
              {{ detail.user&&detail.user.nickName?detail.user.nickName:'' }}
              <span v-if="detail.user">用户ID：({{ detail.user.user_id }})</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单金额 (元)：</span>
              {{ detail.pay_price}}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">实付款金额 (元)：</span>
              {{ detail.pay_price }}
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">实退款金额(元)：</span>
              {{ detail.yi_refund_price }}
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">支付方式：</span>
              {{ detail.pay_type.text }}
            </div>
          </el-col>
     
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">交易状态：</span>
              {{ detail.state_text }}
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">使用状态：</span>
              {{ detail.is_use.text }}
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">不通过原因：</span>
              {{ detail.reject_val }}
            </div>
          </el-col>
        </el-row>
      </div>
<!-- 
      <div class="common-form">服务商信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="7">
            <div class="pb16">
              <span class="gray9">所属{{detail.service.service_role}}：</span>
              {{ detail.service.name }}
            </div>
          </el-col>
         
        </el-row>
      </div> -->

      <!--商品信息-->
      <div class="common-form mt16">设备信息</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.equip" border style="width: 100%">
          <el-table-column prop="product_name" label="设备" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.cover" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.name }}</div>
                  <div class="price">
                    <span >￥ {{detail.pay_price }}</span>
                  
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="num" label="购买时长">
            <template slot-scope="scope">
              <p>{{ detail.minutes }}分钟</p>
            </template>
          </el-table-column>

          <el-table-column prop="num" label="已用时长">
            <template slot-scope="scope">
              <p>{{ detail.use_time?detail.use_time:0 }}分钟</p>
            </template>
          </el-table-column>

          <el-table-column prop="num" label="购买数量">
            <template slot-scope="scope">
              <p>x {{ detail.num }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="设备套餐总价(元)">
            <template slot-scope="scope">
              <p>￥ {{ detail.pay_price }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>




      <!--付款信息-->
      <div class="table-wrap" v-if="detail.pay_status.value == 20">
        <div class="common-form mt16">付款信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">应付款金额：</span>
                {{ detail.pay_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付方式：</span>
                {{ detail.pay_type.text }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.transaction_id ">
              <div class="pb16">
                <span class="gray9">支付流水号：</span>
                {{ detail.transaction_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款状态：</span>
                {{ detail.pay_status.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款时间：</span>
                {{ detail.pay_time }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      
    <!--分佣信息-->
    <div class="common-form mt16" v-if="detail.agent_log && detail.agent_log.length && detail.status.value !=20">分佣信息</div>
    <div class="table-wrap agent_log" v-if="detail.agent_log && detail.agent_log.length && detail.status.value !=20">
      <el-table size="small" :data="detail.agent_log" border style="width: 100%">
        <el-table-column prop="log_type.text" label="类型"></el-table-column>
        <el-table-column prop="grade.name" label="等级"></el-table-column>
        <el-table-column prop="user" label="用户">
          <template slot-scope="scope">
            <div class="user d-s-c d-r">
              <div class="pic"><img v-img-url="scope.row.user.avatarUrl" width="40" height="40" /></div>
              <div class="ml10">
                <div class="name">{{ scope.row.user.nickName }} ({{ scope.row.user.user_id }})</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="rate" label="分佣比例"></el-table-column>
        <el-table-column prop="price" label="佣金"></el-table-column>
        <el-table-column prop="is_settled" label="结算状态">
          <template slot-scope="scope">
            <span v-if="scope.row.is_settled == 0" class="green">未结算</span>
            <span v-if="scope.row.is_settled == 1" class="green">已结算</span>
            <span v-if="scope.row.is_settled == 2" class="gray9">已取消</span>
          </template>
        </el-table-column>
        <el-table-column prop="settle_time" label="结算时间"></el-table-column>
      </el-table>
    </div>


      <div v-if="supply_id==0">
      <!--  用户取消订单 -->
      <div v-if="detail.pay_status.value == 20 && detail.is_refund == 1" >
        <div class="common-form mt16">用户取消订单</div>
        <p class="red pb16">当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。</p>

        <el-form size="small" ref="forms" :model="forms">
   
        <el-form-item label="退款理由" prop="name">
          {{ detail.canel_val }}
        </el-form-item>
      
          
      <el-form-item label="问题图片：" prop="model.image">
          <div class="draggable-list">
            <div v-for="(item, index) in detail.canel_image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path"  @click="opena(item.file_path)" alt="file_path"/>
                   </div>
                </div>
          </div>
        </el-form-item>


        <el-form-item label="问题视频：" prop="model.image">
          <div class="draggable-list">
            <div v-for="(item, index) in detail.canel_video" style="width: 300px;height: 200px;" :key="item.file_path">
                  <div class="item" style="width: 300px;height: 200px;"> 
                    <video controls style="width: 300px;height: 200px;" :src="item" alt="file_path"/>
                   </div>
                </div>
   
          </div>
        </el-form-item>
  
          <el-form-item label="审核状态">
            <div>
              <el-radio v-model="forms.is_cancel" :label="1">同意</el-radio>
              <el-radio v-model="forms.is_cancel" :label="0">拒绝</el-radio>
            </div>
          </el-form-item>

          <!-- <el-form-item><el-button type="primary" @click="confirmCancel()">确认审核</el-button></el-form-item> -->
        </el-form>
      </div>


    </div>
    </div>




    <div class="common-button-wrapper" v-if="is_drawer!='1'">
      <el-button size="small" type="info" @click="cancelFunc" style="margin-right: 10px;" v-if="!this.order_id">返回上一页</el-button>
     <div v-if="supply_id==0">

        <!--用户取消-->
        <template v-if="(detail.pay_status.value == 20 && detail.is_refund == 1)&&(supply_id>0&&supply_setting.order_send>0||supply_id==0)">
          <el-button size="small" type="primary" @click="confirmCancel(detail)">确认审核</el-button>
        </template>

     </div>

    </div>

    <!--选择用户-->
    <deliveryUser :storeId="Number(form.store_id)" :is_open="isOpenGetUser" :multi="false" @close="closeGetUserFunc"></deliveryUser>
  </div>
</template>

<script>
  import OrderApi from '@/api/order.js';
  import ProductApi from '@/api/product.js';
  //import Add from './dialog/Add.vue';
  import deliveryUser from '@/components/user/deliveryUser';
  import {
    deepClone
  } from '@/utils/base.js';
  export default {
    components: {
      //Add,
      deliveryUser,

    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          pay_status: [],
          pay_type: [],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: [],
          delivery_warehouse: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          is_cancel: 1,
    
        },
        extract_form: {
          order: {
            extract_status: 1
          }
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        /*快递公司列表*/
        expressList: [],
        shopClerkList: [],
        /*是否打开编辑弹窗*/
        open_edit: false,
        supply_id:0,
        // 选择用户flag
        isOpenGetUser: false,
        // 选择的配送员列表,只有一个
        select_list: [],
        deliveryForm: {

        },
      };
    },
    props: ['order_id', 'is_drawer'],
    created() {
      // this.is_drawer = this.is_drawer ? this.is_drawer : 0;
      console.log(this.order_id, this.is_drawer);
      /*获取列表*/
      this.getParams();
    },
    methods: {
      opena(file){
        window.open(file)
    },
      addService(){
        this.is_service = true;
      },
      addRemark(order_service_id){
        this.order_service_id = order_service_id;
        this.is_service_remark = true;
       
      },
      flush(){
        this.getParams();
      },
      delChooseService(order_service_id){
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            console.log(1111111);
            ProductApi.delChooseService(
              {
                order_service_id: order_service_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  self.getParams();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.order_id ? this.order_id : this.$route.query.order_id;
        OrderApi.getEquipDetail({
            order_id: params,
            XDEBUG_SESSION_START: 'PHPSTORM',
          }
        ).then(data => {
          self.loading = false;
          self.detail = data.data.detail;
          if (data.data.supply) {
            self.supply = data.data.supply;
            self.supply_id = self.supply.supply_id;
            self.supply_setting = data.data.supply.kmd_grade.setting;
          } else {

          }
        })
          .catch(error => {
            self.loading = false;
          });
      },
      /*确认取消*/
      async confirmCancel(detail) {
        let self = this;
        let order_id = this.$route.query.order_id;
        let is_cancel = self.forms.is_cancel;
        if( is_cancel == 1){
          const money = await this.promptInput('原款：'+detail.pay_price+"元，购买套餐时间:"
          +detail.minutes+"分钟；不填写则为全额退款", '请输入退款金额',detail.pay_price);

          if(money == undefined){
            console.log("取消")
          }else{
              OrderApi.confirmEquip({
                  order_id: order_id,
                  is_cancel: is_cancel,
                  reject_val:"",
                  money:money
                },
                true
              )
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，审核成功',
                  type: 'success'
                });
                self.getParams();
              })
              .catch(error => {
                self.loading = false;
              });
          }
         
      }else if(is_cancel == 0){
        const reject_val = await this.promptInput('请输入不通过的原因', '请输入不通过的原因');

          var Params = {
            order_id: order_id,
                is_cancel: is_cancel,
                reject_val:reject_val
          }
          console.log(reject_val)
          if(reject_val == undefined){
            console.log("取消")
          }else{
              if(reject_val.length > 0){
                OrderApi.confirmEquip(Params, true)
                          .then(data => {
                            if(data.code == 1){
                              self.$message({
                                  type: 'success',
                                  message: '审核成功'
                              });
                                self.getParams();
                                return false;
                            }
                          })
                          .catch(error => {});
              }else{
                this.$message({
                  type: 'error',
                  message: '请输入不通过的原因',
                });
              }

          }
      }
   
    
      },
      async promptInput(message, validation,inputValue="") {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
          inputValue:inputValue
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
      /*核销*/
      onExtract(e) {
        let self = this;
        let extract_form = self.extract_form;
        extract_form.order_id = e;
        OrderApi.extract({
              extract_form
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getParams();
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*打开编辑*/
      editClick(item) {
        this.userModel = deepClone(item);
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          this.getParams();
        }
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开获取用户*/
      openGetUser() {
        this.isOpenGetUser = true
      },
      /*关闭获取用户*/
      closeGetUserFunc(e) {
        if (e.type != 'error') {
          this.select_list = [e.params]
        }
        this.isOpenGetUser = false
      },
      closeServiceFunc(e){
        if (e.type != 'error') {
  
          this.getParams();
        }
        this.is_service = false
        this.is_service_remark = false
      },
      // 确认配送
      confirmDelivery() {
        // select_list
        // if (!Array.isArray(this.select_list)) {
        //   this.$message.error('请选择配送员')
        //   return false
        // }
        // if (this.select_list.length === 0) {
        //   this.$message.error('请选择配送员')
        //   return false
        // }
        let self = this;
        let order_id = this.$route.query.order_id;
        // let deliveryStaffId = self.select_list[0].delivery_staff_id;
        OrderApi.deliveryStaff({
            order_id: order_id,
            // deliveryStaffId: deliveryStaffId,
            // XDEBUG_SESSION_START: 'PHPSTORM',
          }
        ).then(data => {
          self.loading = false;
          self.$message({
            message: '配送成功',
            type: 'success'
          });
          self.getParams()
        }).catch(error => {
          self.loading = false;
        })
      },

      /*计算佣金*/
      addAgentOrder(e){
        let self = this;
        let order_id = e.order_id;
        console.log(order_id, 'order_id');
        self.$confirm('此操作将【确认计算佣金】, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.addAgentOrder({order_id: order_id},true)
            .then(res => {
              self.loading = false;
              self.$message({
                message: res.msg,
                type: 'success'
              });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        }).catch(() => {});
      },

      /*确认结算佣金*/
      settled(e){
        let self = this;
        let order_id = e.order_id;
        console.log(order_id, 'order_id');
        self.$confirm('此操作将【确认结算佣金】, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.settled({order_id: order_id},true)
            .then(res => {
              self.loading = false;
              self.$message({
                message: res.msg,
                type: 'success'
              });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        }).catch(() => {});
      },

    }
  };
</script>
<style>


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/order/equip/detail.vue